import './rewardsDisplay.scss';
import type { Maybe } from '@custom/dx3';
import classNames from 'classnames';
import { type PropsWithChildren, type ReactNode } from 'react';
import { COPY } from '../../assets/copy/copy';
import { usDateFormatter } from '../../utils/formatters';

interface BadgeProps {
  imageUrl?: null | string;
  label?: null | string;
  alt?: null | string;
  subLabel?: Maybe<ReactNode>;
  hideEarnedText?: null | true;
  dateEarned?: null | Date;
  hideLabel?: null | true;
  badgeImageClasses?: null | string;
  horizontal?: null | true;
  contentClasses?: null | string;
  containerClasses?: null | string;
}

export function RewardsDisplay(
  props: PropsWithChildren<BadgeProps>
): JSX.Element {
  const {
    contentClasses,
    imageUrl,
    label,
    subLabel,
    hideLabel,
    hideEarnedText,
    dateEarned,
    badgeImageClasses,
    containerClasses,
    horizontal,
    children,
    alt,
  } = props;

  return (
    <div
      className={classNames(
        containerClasses,
        'rewards-display-badge',
        horizontal ? 'rewards-display-horizontal' : ''
      )}
    >
      <div
        className={classNames(
          contentClasses,
          'rewards-display-content-container'
        )}
      >
        {imageUrl && (
          <img
            src={imageUrl}
            alt={(label || alt) ?? undefined}
            className={badgeImageClasses ?? ''}
          />
        )}
        {children}
      </div>
      {!hideLabel && <div className="rewards-display-label">{label}</div>}
      {!hideEarnedText && dateEarned && (
        <div className="grey small-text">
          {COPY.BADGES.EARNED} {usDateFormatter.format(dateEarned)}
        </div>
      )}
      {!hideLabel && <div className="rewards-display-sublabel">{subLabel}</div>}
    </div>
  );
}
